const role = {
    name: "Role",
    items: {
        SUPER_ADMIN: {
            value: 1,
            text: "Super Admin",
            name: "SUPER_ADMIN"
        },
        TERRITORY_MANAGER: {
            value: 2,
            text: "Territory Manager",
            name: "TERRITORY_MANAGER"
        },
        ADMIN: {
            value: 3,
            text: "Admin",
            name: "ADMIN"
        },
        PARNELL_VIEWER: {
            value: 4,
            text: "Parnell Viewer",
            name: "PARNELL_VIEWER"
        },
        VIEWER: {
            value: 5,
            text: "Viewer",
            name: "VIEWER"
        },
        DEMO_USER: {
            value: 5,
            text: "Demo User ",
            name: "DEMO_USER"
        }
    }
}
export const Role = role;